<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">事前仮予約検索</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load()" class="btn-search" v-permit.BOOKING_SEARCH>{{
          $t("app.buttons.search")
        }}</v-btn>
        <v-btn v-permit.BOOKING_NEW @click="$router.push('/B2201/New')"
          >新規</v-btn
        >
        <v-btn
          v-permit.BOOKING_EDIT
          :disabled="selected.length != 1"
          @click="edit()"
          >編集</v-btn
        >
        <v-btn
          v-permit.BOOKING_REMOVE
          :disabled="selected.length != 1"
          @click="cancelBookingSa()"
          >削除</v-btn
        >
        <v-btn
          v-permit.BOOKING_MAIL_SEND
          :disabled="selected.length != 1"
          @click="mailSend()"
          >送信</v-btn
        >
        <v-btn
          v-permit.BOOKING_MAIL_CANCEL_SEND
          :disabled="selected.length != 1"
          @click="mailSendCancel()"
          >送信解除</v-btn
        >
        <v-btn @click="$clearQuery()">検索条件クリア</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.partner')"
                url="companies/kvt?type=PARTNER"
                v-model="query.partnerId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                :label="$t('app.labels.bu.name')"
                url="divisions/kv?type=BU"
                v-model="query.buHeadquartersId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="B/L No" v-model="query.blNo" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <remote-autocomplete
                label="船社名"
                url="companies/forwarders/kv"
                v-model="query.forwarderId"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field label="本船名" v-model="query.shipName" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field label="Ｖｏｙ　ＮＯ" v-model="query.volNo" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :max="query.etdTo"
                    label="ETD"
                    v-model="query.etdFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etdFrom"
                    v-model="query.etdTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-input
                    :max="query.etaTo"
                    label="ETA"
                    v-model="query.etaFrom"
                  ></date-input>
                </v-flex>
                <v-flex md1 style="margin-top: 15px">~</v-flex>
                <v-flex md5>
                  <date-input
                    :min="query.etaFrom"
                    v-model="query.etaTo"
                  ></date-input>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.loadingPort')"
                url="ports/kv"
                v-model="query.loadingPortCode"
              ></remote-autocomplete>
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                :label="$t('app.labels.dischargePort')"
                url="ports/kv"
                v-model="query.dischargePortCode"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <fixed-column-wrap :data="pagination.content">
        <template slot-scope="{}">
          <v-data-table
            :headers="headers"
            :items="pagination.content"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="[10]"
            :total-items="pagination.totalItems"
            class="inline-edit"
            item-key="id"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  hide-details
                  primary
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                {{
                  props.item.headquarterCode + ":" + props.item.headquarterName
                }}
              </td>
              <td>
                {{ props.item.partnerCode + ":" + props.item.partnerName }}
              </td>
              <td>{{ props.item.blNo }}</td>
              <td>
                {{ props.item.forwarderCode + ":" + props.item.forwarderName }}
              </td>
              <td>{{ props.item.shipName }}</td>
              <td>{{ props.item.volNo }}</td>
              <td>{{ props.item.etd }}</td>
              <td>{{ props.item.eta }}</td>
              <td>
                {{
                  props.item.loadingPortCode + ":" + props.item.loadingPortName
                }}
              </td>
              <td>
                {{
                  props.item.dischargePortCode +
                  ":" +
                  props.item.dischargePortName
                }}
              </td>
              <td>{{ props.item.createDate }}</td>
              <td>{{ props.item.bookingCreatedBy }}</td>
              <td>{{ props.item.status }}</td>
              <td>
                <v-btn @click="openBlDetail(props.item)">送信先設定</v-btn>
              </td>
            </template>
          </v-data-table>
        </template>
      </fixed-column-wrap>
    </v-card>
    <bl-dialog @refresh="load" ref="blDialog"></bl-dialog>
  </v-container>
</template>

<script>
import BlDialog from "./dialog";
export default {
  components: {
    BlDialog,
  },
  methods: {
    upload(data) {
      var start = null;
      var shipmentList = [];
      var promiseArray = [];
      var errors = [];

      for (let i = 0; i < data.length; i++) {
        if (data[i][0] === "タイプ") {
          start = i;
          break;
        }
      }

      var currentShipment = null;

      for (var i = start + 1; i < data.length; i++) {
        console.log(data[i]);
        let d = data[i];

        if (d[0]) {
          if (!this.checkDateFormat(String(d[7]))) {
            this.$message("", d[3] + "：etd failed");
            return;
          }
          if (!this.checkDateFormat(String(d[8]))) {
            this.$message("", d[3] + "：eta failed");
            return;
          }
          currentShipment = null;
          let newShipment = {
            packages: [],
          };
          let pkg = {};
          shipmentList.push(newShipment);
          currentShipment = newShipment;
          newShipment.bookingType = this.exchangeType(data[i][0]);
          newShipment.buCode = d[1] && d[1].split(":") && d[1].split(":")[0];
          newShipment.partnerCode =
            d[2] && d[2].split(":") && d[2].split(":")[0];
          newShipment.blNo = d[3];
          newShipment.forwarderCode =
            d[4] && d[4].split(":") && d[4].split(":")[0];
          newShipment.shipName = d[5];
          newShipment.volNo = d[6];
          newShipment.etd = this.dateFormat(String(d[7]));
          newShipment.eta = this.dateFormat(String(d[8]));
          console.log(newShipment.etd);
          console.log(newShipment.eta);
          newShipment.loadingPortCode =
            d[9] && d[9].split(":") && d[9].split(":")[0];
          newShipment.dischargePortCode =
            d[10] && d[10].split(":") && d[10].split(":")[0];
          pkg.containerNo = d[11];
          pkg.containerTypeId = this.exchangeContainerSize(d[12]);
          pkg.skuCode = d[13];
          pkg.totalQty = d[14];
          pkg.seq = new Date().getTime() + i * 1000;
          pkg.itemSeq = new Date().getTime() + i * 10000;
          currentShipment.packages.push(pkg);
          currentShipment = newShipment;
        }
        if (!d[0] && (d[11] || d[12] || d[13] || d[14])) {
          let pkg = {};
          pkg.containerNo = d[11];
          pkg.containerTypeId = this.exchangeContainerSize(d[12]);
          pkg.skuCode = d[13];
          pkg.totalQty = d[14];
          pkg.seq = new Date().getTime() + i * 1000;
          pkg.itemSeq = new Date().getTime() + i * 10000;
          currentShipment.packages.push(pkg);
        }
      }

      shipmentList.forEach((l) => {
        promiseArray.push(this.createShipment(l, errors));
      });

      console.log("promiseArray", promiseArray);

      Promise.allSettled(promiseArray).then((res) => {
        console.log("kkkk");
        console.log(res);
        console.log("errors", errors);
        if (errors.length > 0) {
          this.$fullMessage("", errors);
        } else {
          this.$message("", "success");
        }
      });
    },

    createShipment(shipment, errors) {
      return this.$http
        .post("/shipping-advices/create-booking-sas", shipment)
        .then((res) => {
          console.log("success", shipment.blNo);
        })
        .catch((err) => {
          console.log(err.response.data.message);
          console.log("error", shipment.blNo);
          errors.push({
            blNo: shipment.blNo,
            errors: err.response.data.message,
          });
        });
    },

    getCompanyId(companyType, companyCode) {
      return this.$http.get(`/companies/code/${companyType}/${companyCode}`);
    },
    dateFormat(v) {
      return v.replace(/^(\d{4})(\d{2})(\d{2})$/, "$1-$2-$3");
    },

    checkDateFormat(v) {
      return /^(((?:19|20)\d\d)(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01]))$/.test(
        v
      );
    },

    exchangeType(type) {
      switch (type) {
        case "ブッキング":
          return "booking";
        case "バンニング":
          return "vanneing";
      }
    },
    exchangeContainerSize(size) {
      switch (size) {
        case "20F":
          return "CONTAINER_TYPE-20F";
        case "40F":
          return "CONTAINER_TYPE-40F";
        case "40H":
          return "CONTAINER_TYPE-40FHQ";
        case "40HQ":
          return "CONTAINER_TYPE-40FHQ";
      }
    },
    load() {
      this.$storeParams();
      this.autoload = true;
      this.selected = [];
      this.$http
        .get("/shipping-advices?view=B2200", {
          params: {
            ...this.query,
            ...this.$pageable(),
          },
        })
        .then((res) => {
          this.$pagination(res.data);
        });
    },
    edit() {
      this.$router.push({
        name: "B2201Edit",
        query: {
          id: this.selected[0].id,
        },
      });
    },
    cancelBookingSa() {
      this.$confirm({
        content: "当該仮予約データを削除しても宜しいでしょうか?",
      }).then(() => {
        this.$http
          .put(`shipping-advices/booking-sa/cancel/${this.selected[0].id}`)
          .then(() => {
            this.$message("", "当該データを削除しました。"); //'取消が完了しました。'
            this.load();
          })
          .catch((res) => this.$showError(res));
      });
    },
    openBlDetail(item) {
      this.$http
        .get(`/companies/bu/${item.headquarterCode}/delivery-director`)
        .then((res) => {
          this.$refs.blDialog.popup(res.data, item);
        });
    },
    mailSend() {
      var shipment = this.selected[0];
      if (!shipment.bookingType) {
        this.$message("", "请完善数据后再送信");
        return;
      }
      let id = shipment.id;
      if (shipment.deliveryDirectorCount === 0) {
        this.$message("", "纳入指示者不存在");
        this.selected = [];
        return;
      }

      this.$confirm({
        content: "確定送信してよろしいでしょうか？",
      }).then(() => {
        this.$http
          .put(`shipping-advices/booking-sa-send/${id}`)
          .then(() => {
            this.$message("", "Success");
            this.load();
            this.selected = [];
          })
          .catch((res) => this.$showError(res));
      });
    },
    mailSendCancel() {
      let id = this.selected[0].id;
      this.$confirm({
        content: "送信解除してよろしいでしょうか？",
      }).then(() => {
        this.$http
          .put(`/shipping-advices/booking-sa-send-cancel/${id}`)
          .then(() => {
            this.$message("", "Success");
            this.load();
          })
          .catch((res) => this.$showError(res));
      });
    },
  },
  data() {
    return {
      results: [],
      loading: false,
      query: {},
      selected: [],
      dialog: {
        show: false,
      },
      historyData: [],
      pagination: {
        page: 0,
      },
      errors: {
        INVALID_SA_STATUS: this.$t("B0400.messages.errors.sa_status_invalid"), //'S/A取消してください。',
        INVALID_INV_STATUS: this.$t("B0400.messages.errors.inv_canceled"), //'I/V取消してください',
        INVALID_STATUS: this.$t("B0400.messages.errors.do_not_relieve"), //'DO未解除或DO解除未确认'
        CAN_NOT_CANCEL: "无法取消送信",
        TEMP_WITHOUT_PRODUCT: "品種名は必須としてください。",
        HAS_SENT: "事前仮予約送信済",
        SKU_NOT_FOUND: "品番が存在していません。",
      },
      headers: [
        {
          text: "事業本部",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "海外取引先",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "B/L No",
          value: "",
          sortable: false,
          class: "fixed",
        },
        {
          text: "船社名",
          value: "",
          sortable: false,
        },
        {
          text: "本船名",
          value: "",
          sortable: false,
        },
        {
          text: "Ｖｏｙ　ＮＯ",
          value: "",
          sortable: false,
        },
        {
          text: "ETD",
          value: "",
          sortable: false,
        },
        {
          text: "ETA",
          value: "",
          sortable: false,
        },
        {
          text: "積出港",
          value: "",
          sortable: false,
        },
        {
          text: "陸揚港",
          value: "",
          sortable: false,
        },
        {
          text: "作成時間",
          value: "",
          sortable: false,
        },
        {
          text: "作成者",
          value: "",
          sortable: false,
        },
        {
          text: "送信状態",
          value: "status",
          sortable: false,
        },
        {
          text: "ACTION",
          value: "",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.$loadParams();
  },
  computed: {},
  watch: {
    pagination() {
      if (this.autoload) this.load();
    },
  },
};
</script>
